module.exports = __webpack_public_path__ + "media/parts/Info_Icon-01-3bdfb490.svg";